/**
 * 页面权限
 */
export const INQUIRY_AUCTION_LIST_PAGE_UUID =
  'd5fcd6c1-e352-4e24-bb62-3c2569c4a713'
